import { render, staticRenderFns } from "./GoalLinkTransaction.vue?vue&type=template&id=56df3970"
import script from "./GoalLinkTransaction.vue?vue&type=script&lang=js"
export * from "./GoalLinkTransaction.vue?vue&type=script&lang=js"
import style0 from "./GoalLinkTransaction.vue?vue&type=style&index=0&id=56df3970&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports